import { TermCourseServant } from '../../term_courses/servants/term_course_servant';
import { ScheduledSectionStatusServant } from '../../course_scheduler/servants/scheduled_section_status_servant';
import { UnscheduledSectionServant } from '../../unscheduled_sections/servants/unscheduled_section_servant';
import { ISection, ICalendarSection, ICalendarBusyTime } from '../../../interfaces/scheduler_interfaces';
import * as _4 from 'lodash4';
import { SectionSwapModel } from '../../../swap/models/course_section_swap_model';
import { SectionTypeFilters } from '../../term_courses/filters/section_type_filters';
import { AllSectionsQuery } from '../../course_scheduler/queries/all_sections_query';

export class CalendarScheduledSectionServant {
  constructor(
    private ngUnscheduledSectionServant: UnscheduledSectionServant,
    private getCSSClassForString: any,
    private CampusLocationEnum: any,
    private ngScheduledSectionStatusServant: ScheduledSectionStatusServant,
    private ngTermCourseServant: TermCourseServant,
    private ngSectionTypeFilters: SectionTypeFilters,
    private ngAllSectionsQuery: AllSectionsQuery,
    private ngCourseSectionSwapModel: SectionSwapModel
  ) {}
  buildUnavailableTimes(unavailableTimes: any[]): ICalendarBusyTime[] {
    return _4.compact(
      _4.map(unavailableTimes, (unavailableTime) => ({
        id: unavailableTime.id,
        day_of_week: unavailableTime.day.value.ordinal,
        from_tm: unavailableTime.from.format('HH:mm:ss'),
        to_tm: unavailableTime.to.format('HH:mm:ss'),
        repeats_every: 1,
        bkgColorClass: 'clr-tertiary-color_6_bkg',
        content: '',
        isLocked: false
      }))
    );
  }
  // TODO: Refactor large function
  /* tslint:disable:cognitive-complexity */
  buildCalendarSections(scheduledSections: ISection[]) {
    const NOT_SURE_DAY = 8;

    const calendarSections: ICalendarSection[] = [];
    _4.each(scheduledSections, (scheduledSection: ISection) => {
      const sectionName = _4.get(scheduledSection, '_course.cd', '');
      const sectionDays = _4.map(scheduledSection._section_times, 'day_of_week');
      const hasOnlineSection = _4.get(scheduledSection, '_campus.is_online', false);

      const hasOneDayMinimum = _4.size(_4.uniq(sectionDays)) > 0;

      const isWaitlisted = this.ngScheduledSectionStatusServant.isStatusWaitlisted(scheduledSection);

      const isRegistered =
        this.ngScheduledSectionStatusServant.isStatusRegistered(scheduledSection) ||
        this.ngScheduledSectionStatusServant.isStatusCompleted(scheduledSection) ||
        this.ngScheduledSectionStatusServant.isStatusInProgress(scheduledSection);

      const isWithdrawn = this.ngScheduledSectionStatusServant.isStatusWithdrawn(scheduledSection);

      // FIXME: Conflicting info not available from server.
      const isConflicting =
        !_4.isEmpty(scheduledSection._availability) &&
        this.ngUnscheduledSectionServant.isSectionConflicting(scheduledSection);
      const hasWarning = this.showWarningIcon(scheduledSection);
      const isSwapFrom = _4.some(this.ngCourseSectionSwapModel.read().swap_from_section_ids, {
        id: scheduledSection.id
      });

      const isSwapTo = _4.some(this.ngCourseSectionSwapModel.read().swap_to_section_ids, { id: scheduledSection.id });

      const isShortSection = this.ngSectionTypeFilters.isSectionDurationShorterThanTerm(scheduledSection);

      const iconsMap = {
        warning: isConflicting || hasWarning,
        laptop: hasOnlineSection && !hasOneDayMinimum,
        blended: hasOnlineSection && hasOneDayMinimum,
        users: isWaitlisted,
        skating: isShortSection
      };
      const hoverContent = {
        title: scheduledSection._course
          ? `${scheduledSection._course.cd} - ${scheduledSection._course.title}`
          : `${scheduledSection.cd}`,
        hoverContent: `<div class="pam min-w-360"><calendar-scheduled-section section-id="${scheduledSection.id}"></calendar-scheduled-section></div>`
      };

      const courseColor = this.getCSSClassForString(_4.get(scheduledSection, '_course.nk', ''));
      const sectionsWithTimes = _4.filter(
        scheduledSection._section_times,
        (c) => c.day_of_week < 8 && c.to_tm && c.from_tm
      );

      const section = scheduledSection;
      _4.each(sectionsWithTimes, (sectionTime) => {
        calendarSections.push({
          id: scheduledSection.id,
          day_of_week: sectionTime.day_of_week,
          from_tm: sectionTime.from_tm || '00:00:00',
          to_tm: sectionTime.to_tm || '00:00:00',
          from_dt: sectionTime.from_dt || '',
          to_dt: sectionTime.to_dt || '',
          repeats_every: 1,
          bkgColorClass: courseColor,
          content: sectionName,
          hover: hoverContent,
          isLocked: true,
          isWithdrawn,
          isRegistered,
          isWaitlisted,
          isSwapFrom,
          isSwapTo,
          isWarning: hasWarning || isConflicting,
          icons: _4.keys(_4.pickBy(iconsMap, (value, key) => value)),
          section
        });
      });

      if (hasOnlineSection) {
        const onlineSectionIcon = 'laptop';
        calendarSections.push({
          id: scheduledSection.id,
          day_of_week: NOT_SURE_DAY,
          from_tm: '00:00:00',
          to_tm: '00:00:00',
          repeats_every: 1,
          bkgColorClass: courseColor,
          content: sectionName,
          hover: hoverContent,
          isLocked: true,
          isRegistered,
          isWithdrawn,
          isWarning: hasWarning || isConflicting,
          isWaitlisted,
          isSwapFrom,
          isSwapTo,
          icons: hasWarning || isConflicting ? ['warning', onlineSectionIcon] : [onlineSectionIcon],
          section
        });
      }
    });
    const nonWithdrawnOfflineOnlineCourses = _4.partition(
      _4.filter(calendarSections, (calSection: ICalendarSection) => !calSection.isWithdrawn),
      (o) => o.day_of_week !== NOT_SURE_DAY
    );

    return _4.compact([
      ...nonWithdrawnOfflineOnlineCourses[0],
      ..._4.uniqBy(nonWithdrawnOfflineOnlineCourses[1], 'id')
    ]);
  }

  removeInvalidTime(times: any[]) {
    return _4.remove(times, (item) => item.day_of_week !== 8 && item.to_tm === '00:00:00');
  }

  showWarningIcon(section: ISection) {
    // Show warning when missing coreq or prereq.
    const isMissingCoReqOrPreReq =
      !_4.isEmpty(_4.get(section, '_course._missing_prereqs')) ||
      !_4.isEmpty(_4.get(section, '_course._missing_coreqs'));
    return isMissingCoReqOrPreReq;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/calendar/servants/calendar_scheduled_section_servant.ts